/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Group_LabelInputs */

const en_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marker Group`)
};

const fr_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe de marqueurs`)
};

const de_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markergruppe`)
};

const it_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di marcatori`)
};

const ru_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа маркеров`)
};

const es_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de marcadores`)
};

const zh_cn2_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标记组`)
};

const ja_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーカーグループ`)
};

const hi_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर समूह`)
};

const pt_pt2_marker_import_group_label = /** @type {(inputs: Marker_Import_Group_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Marcadores`)
};

/**
* | output |
* | --- |
* | "Marker Group" |
*
* @param {Marker_Import_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_group_label = /** @type {((inputs?: Marker_Import_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_group_label(inputs)
	if (locale === "de") return de_marker_import_group_label(inputs)
	if (locale === "it") return it_marker_import_group_label(inputs)
	if (locale === "ru") return ru_marker_import_group_label(inputs)
	if (locale === "es") return es_marker_import_group_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_group_label(inputs)
	if (locale === "ja") return ja_marker_import_group_label(inputs)
	if (locale === "hi") return hi_marker_import_group_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_group_label(inputs)
	return en_marker_import_group_label(inputs)
});